import { $remark } from "@milkdown/utils"
import { InitReady, remarkPluginsCtx } from "@milkdown/kit/core"
import remarkGFM from "remark-gfm"
import { gfmAutolinkLiteral } from "micromark-extension-gfm-autolink-literal"
import { gfmStrikethrough } from "micromark-extension-gfm-strikethrough"
import { gfmTable } from "micromark-extension-gfm-table"
import { gfmTaskListItem } from "micromark-extension-gfm-task-list-item"
import {
	gfmAutolinkLiteralFromMarkdown,
	gfmAutolinkLiteralToMarkdown,
} from "mdast-util-gfm-autolink-literal"
import {
	gfmStrikethroughFromMarkdown,
	gfmStrikethroughToMarkdown,
} from "mdast-util-gfm-strikethrough"
import { gfmTableFromMarkdown, gfmTableToMarkdown } from "mdast-util-gfm-table"
import {
	gfmTaskListItemFromMarkdown,
	gfmTaskListItemToMarkdown,
} from "mdast-util-gfm-task-list-item"

// The four GFM constructs a note shares with pages/markdown.go, assembled the
// way remark-gfm assembles all five. Footnotes are the fifth, and remark-gfm has
// no switch for a single construct, so the set is named here instead. The
// identity filter below needs there to be one copy of remark-gfm in the tree;
// editor.e2e.js "leaves footnote syntax as text" is what says there still is.
const micromarkExtensions = [
	gfmAutolinkLiteral(),
	gfmStrikethrough(),
	gfmTable(),
	gfmTaskListItem(),
]
const fromMarkdownExtensions = [
	gfmAutolinkLiteralFromMarkdown(),
	gfmStrikethroughFromMarkdown(),
	gfmTableFromMarkdown(),
	gfmTaskListItemFromMarkdown(),
]
const toMarkdownExtensions = [
	gfmAutolinkLiteralToMarkdown(),
	gfmStrikethroughToMarkdown(),
	gfmTableToMarkdown(),
	gfmTaskListItemToMarkdown(),
]

function remarkGfmWithoutFootnotes() {
	const data = this.data()
	for (const [field, values] of [
		["micromarkExtensions", micromarkExtensions],
		["fromMarkdownExtensions", fromMarkdownExtensions],
		["toMarkdownExtensions", toMarkdownExtensions],
	]) {
		const list = data[field] || (data[field] = [])
		list.push(...values)
	}
}

const gfmWithoutFootnotes = $remark("gfmWithoutFootnotes", () => remarkGfmWithoutFootnotes)

// Crepe's gfm preset registers remark-gfm on InitReady rather than at config
// time, so the swap waits for the same signal — and is used after that preset,
// which is what puts it second in the queue.
const dropRemarkGFM = (ctx) => async () => {
	await ctx.wait(InitReady)
	ctx.update(remarkPluginsCtx, (plugins) =>
		plugins.filter((entry) => entry.plugin !== remarkGFM)
	)
}

export const gfmWithoutFootnotesPlugin = [dropRemarkGFM, gfmWithoutFootnotes].flat()
